export default function setTitle(text) {
    const title = document.querySelector("title")
    if (!title || !text || text === title.text) { return }
    title.text = text
    title.dispatchEvent(new Event("update", { text }))
}